<!-- <app-layout-dialogheader1 [title]="'Upload files'" [titlesub]="''" mat-dialog-title></app-layout-dialogheader1> -->
<mat-dialog-content>

  <app-fr-fileuploadview [title]="'File upload for flight'" [uploadinfo]="uploadinfo" [maxsizePerFile]="500000000" [showAll]="false"></app-fr-fileuploadview>

</mat-dialog-content>

<div mat-dialog-actions style="width:100%;" class="justify-content-end">
    <button mat-raised-button mat-dialog-close class="btn pull-right">Close</button>
</div>
